var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g(_vm._b({staticClass:"button",class:{
    'is-busy': _vm.busy,
    'button--solid': _vm.solid
  },attrs:{"disabled":_vm.busy || _vm.$attrs.disabled}},'button',_vm.$attrs,false),_vm.$listeners),[_c('c-busy',{staticClass:"button__busy"}),_c('span',{staticClass:"button__content"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }